export enum DashboardSaveMode {
	AUTO = 'auto',
	MANUAL = 'manual'
}
